import { AfterViewInit, ChangeDetectorRef, Component, ComponentFactoryResolver, ComponentRef, EventEmitter, Input, OnInit, Output, Type, ViewChild, ViewContainerRef } from '@angular/core';
import { Utenteservice } from '../../../services/utente.service';
import { OverlaySideFormService } from '../../shared/overlay-side-form/overlay-side-form.service';
import { HttpClient } from '@angular/common/http';
import { ComponentService } from '../../../services/component.service';
import { NicaAnagraficaComponent } from '../../nica-anagrafica/nica-anagrafica.component';
import { environment } from '../../../../environments/environment';
import notify from 'devextreme/ui/notify';
import { saveAs } from 'file-saver';

export interface IFile {
  id: number;
  idTabella?: string;
  nomeTabella?: string;
  fileOrigine?: string;
  fileGuid?: string;
  dimensione?: number;
  note?: string;
  tipoFile?: string;
  folder?: string;
  ordine?: number;
  percorso?: string;
  idTag?: number;
  parolaChiave?: string;
  idTabellaPadre?: string;
  nomeTabellaPadre?: string;
};
@Component({
  selector: 'app-crm-files-list',
  templateUrl: './crm-files-list.component.html',
  styleUrls: ['./crm-files-list.component.css']
})
export class CrmFilesListComponent implements OnInit, AfterViewInit {
  @ViewChild('dataGridAllegati', { static: false }) dataGridAllegati: NicaAnagraficaComponent;
  @ViewChild('anteprimaPDF', { static: false, read: ViewContainerRef }) anteprimaPDF: ViewContainerRef;
  @Input() queryString: any = '';
  // espando contatti = allegati?nomeTabella=[nomeTabella]&idTabella=[idTabella]
  //espando ul = allegati?nomeTabella=[nomeTabella]&idTabella=[idTabella]&idTabellaPadre=[idTabellaPadre]&nomeTabellaPadre=[nomeTabellaPadre]
  @Input() dataJson: any
  @Output() emittedData: EventEmitter<any> = new EventEmitter<any>(); //Emit all'esterno
  filePreviews = {
    'pdf': 'https://upload.wikimedia.org/wikipedia/commons/thumb/3/38/Icon_pdf_file.svg/1795px-Icon_pdf_file.svg.png',
    'xls': 'https://upload.wikimedia.org/wikipedia/commons/thumb/3/31/Microsoft_Office_Excel_%282013%E2%80%932019%29.svg/2048px-Microsoft_Office_Excel_%282013%E2%80%932019%29.svg.png',
    'xlsx': 'https://upload.wikimedia.org/wikipedia/commons/thumb/3/31/Microsoft_Office_Excel_%282013%E2%80%932019%29.svg/2048px-Microsoft_Office_Excel_%282013%E2%80%932019%29.svg.png',
    'csv': 'https://upload.wikimedia.org/wikipedia/commons/thumb/3/31/Microsoft_Office_Excel_%282013%E2%80%932019%29.svg/2048px-Microsoft_Office_Excel_%282013%E2%80%932019%29.svg.png',
    'docx': 'https://upload.wikimedia.org/wikipedia/commons/thumb/8/8d/Microsoft_Word_2013-2019_logo.svg/254px-Microsoft_Word_2013-2019_logo.svg.png',
    'doc': 'https://upload.wikimedia.org/wikipedia/commons/thumb/8/8d/Microsoft_Word_2013-2019_logo.svg/254px-Microsoft_Word_2013-2019_logo.svg.png',
    'ppt': 'https://upload.wikimedia.org/wikipedia/commons/1/16/Microsoft_PowerPoint_2013-2019_logo.svg',
    'pptx': 'https://upload.wikimedia.org/wikipedia/commons/1/16/Microsoft_PowerPoint_2013-2019_logo.svg',
    'zip': 'https://upload.wikimedia.org/wikipedia/commons/thumb/6/61/7zip_archive_icon.svg/2048px-7zip_archive_icon.svg.png',
    '7zip': 'https://upload.wikimedia.org/wikipedia/commons/thumb/6/61/7zip_archive_icon.svg/2048px-7zip_archive_icon.svg.png',
    'txt': 'https://upload.wikimedia.org/wikipedia/commons/thumb/e/e8/.txt_OneDrive_icon.svg/1200px-.txt_OneDrive_icon.svg.png',
    'rar': 'https://www.wikibit.it/wp-content/uploads/2017/06/rar.png',
  }

  tempPopupEvent: any = undefined;
  idTabella: number;
  nomeTabella: string;
  idTabellaPadre: number;
  nomeTabellaPadre: string;
  fileCaricato?: File;
  mimeType?: string;
  stoModificandoAllegato: boolean = false;
  mostraPopupAnteprima: boolean = false;
  imgFormID: string = 'dropzone-image';
  allegatoDaModificare?: IFile;
  captionAllegati: string = "Inserimento File";
  buttonCustom = [
    {
      location: "after",
      stylingMode: "text",
      widget: "dxButton",
      locateInMenu: "never",
      text: 'Salva',
      icon: "glyphicon mdi mdi-content-save-outline",
      event: 'salva',
      cssClass: 'escludiQuesto',
    },

    {
      location: "after",
      stylingMode: "text",
      widget: "dxButton",
      locateInMenu: "never",
      text: 'Annulla',
      icon: "glyphicon glyphicon icon-annulla-form",
      event: 'annulla',
      cssClass: 'escludiQuesto'
    },
  ];


  pulsanteFooterAllegati = {
    location: "after",
    widget: "dxButton",
    locateInMenu: "never",
    stylingMode: 'text',
    text: 'Chiudi',
    icon: "dx-icon dx-icon-close",
    event: 'chiudiPopup',
    class: '',
    onClick: () => {
      if (this.overlaySide)
        this.overlaySide.close();
    }
  };

  constructor(
    private httpClient: HttpClient,
    private cdr: ChangeDetectorRef,
    public overlaySide: OverlaySideFormService,
    private userservice: Utenteservice,
    public userComponentService: ComponentService,
  ) { }
  ngAfterViewInit(): void {

  }
  ngOnInit(): void {
    this.fileUploaderEventMouseMoving = this.fileUploaderEventMouseMoving.bind(this);
    this.fileUploaderOnDrop = this.fileUploaderOnDrop.bind(this);

    if (this.dataJson['idTabella'] && this.dataJson['nomeTabella']) {
      this.idTabella = this.dataJson['idTabella'];
      this.nomeTabella = this.dataJson['nomeTabella'];
    }
    if (this.dataJson['idTabellaPadre'] && this.dataJson['nomeTabellaPadre']) {
      this.idTabellaPadre = this.dataJson['idTabellaPadre'];
      this.nomeTabellaPadre = this.dataJson['nomeTabellaPadre'];
    }
  }

  async onOptionalButtonClick(evt) {
    //console.log(evt)
    let id: number = evt.row.data.id;
    let allegato = await this.httpClient.get<IFile>(environment.BASE_API_URL.concat(`Allegato/${id}`)).toPromise();
    switch (evt.name) {
      case 'anteprimaAllegato': {
        let link = environment.BASE_API_URL.concat("allegato/download?idTabella=" + allegato.idTabella + "&nomeTabella=" + allegato.nomeTabella + "&fileGuid=" + allegato.fileGuid)
        const options = {
          method: 'GET', // Metodo della richiesta (es. GET, POST, PUT, DELETE)
          headers: {
            'Content-Type': 'application/json', // Specifica il tipo di contenuto
            'Authorization': 'Bearer ' + this.userservice.DammiToken(), // Esempio di header di autenticazione           
          }
        };
        if (!allegato.tipoFile.toLowerCase().includes('pdf') && !(allegato.fileOrigine as string).toLowerCase().endsWith('.pdf')) {
          fetch(link, options).then(
            (res) => {
              res.blob().then(
                (blob: Blob) => {
                  saveAs(blob, allegato.fileOrigine);
                });
            }
          )
          return;
        }
        fetch(link, options).then(
          (res) => {
            res.blob().then(
              (blob: Blob) => {
                let instanceData = {
                  isFile: true,
                  height: '800px',
                  $title: allegato.fileOrigine,
                  tipoFile: 'application/pdf',
                  caricamentoTerminato: true,
                  fileURL: URL.createObjectURL(blob),
                  fileData: blob,
                };
                const id = 'AnteprimaPDfComponent';
                let title = 'Anteprima di Stampa';
                this.userComponentService.setNewPopUp(id, 'AnteprimaPDfComponent', [], '1200', null, instanceData, false, true, title, 'top')
                this.userComponentService.outputComponent.subscribe(res => {
                  if (res.name == 'close') {
                    this.userComponentService.destroyCurrentOpenPopUpByGuid(id)
                  }
                })
              });
          })
      } break;
    }
  }


  async onAllEventAllegato(evt: any) {

    if (evt.name == "onInitNewRow") {
      evt.cancel = true;
      this.stoModificandoAllegato = false;

      let instanceData =
      {
        SubjectCall: 'CrmFilesForm',
        id: 'crmFilesForm',
        ngClass: "soggetto-form",
        type: "simpleForm",
        disableEditForm: true,
        heightForm: "300",
        toolbarBottom: "true",
        dataJson: [],
        CustomButtonSetForm: this.buttonCustom,
        nCol: "2"
      };

      this.captionAllegati = 'Aggiunta File';
      let guid = Math.random().toString().replace("0.", "")
      this.userComponentService.setNewPopUp(guid, 'NicaFormComponent', null, '855', null, instanceData, false, true, this.captionAllegati);

      this.userComponentService.outputComponent.subscribe(async (currentOutput) => {
        if (guid == currentOutput.guid) {
          await this.onFormEvent(currentOutput, guid);
        }
      });

      this.cdr.detectChanges();
    }
    if (evt.name == "onEditorPrepared") {
      evt.cancel = true;
      this.cdr.detectChanges();
      this.stoModificandoAllegato = true;

      let instanceData =
      {
        SubjectCall: 'CrmFilesForm',
        id: 'crmFilesForm',
        ngClass: "soggetto-form",
        type: "simpleForm",
        disableEditForm: true,
        heightForm: "300",
        toolbarBottom: "true",
        dataJson: [],
        CustomButtonSetForm: this.buttonCustom,
        nCol: "2"
        //(emittendButtonPush):"gestisciEventoPulsante($event)"
      };

      let allegatoDaModificare: IFile = await this.httpClient.get<IFile>(environment.BASE_API_URL.concat(`Allegato/${evt.data.id}`)).toPromise();

      if (!allegatoDaModificare) {
        this.allegatoDaModificare = undefined;
        this.stoModificandoAllegato = false;
        return;
      }

      this.captionAllegati = `File: ${allegatoDaModificare.fileOrigine}`;
      let guid = Math.random().toString().replace("0.", "");
      this.userComponentService.setNewPopUp(guid, 'NicaFormComponent', null, '855', { allegatoDaModificare }, instanceData, false, true, this.captionAllegati);

      this.userComponentService.outputComponent.subscribe(async (currentOutput) => {
        if (guid == currentOutput.guid) {
          await this.onFormEvent(currentOutput, guid);
        }

      });
    }
  }


  fileUploaderEventMouseMoving(ev: DragEvent) {
    ev.preventDefault();
    ev.stopPropagation();
    if ((ev.target as HTMLElement).id !== "dropzone") {
      ev.dataTransfer.effectAllowed = "none";
      ev.dataTransfer.dropEffect = "none";
      if (document.getElementById("dropzone")) {
        document.getElementById("dropzone").style.backgroundColor = "rgba(183, 183, 183, 0.1)";
        document.getElementById("dropzone").ondrop = () => {
          return;
        }
      }
      return;
    }
    document.getElementById("dropzone").style.backgroundColor = "var(--giallo)";
    document.getElementById("dropzone").ondrop = (evt) => {
      this.fileUploaderOnDrop(evt);
    }
  }

  fileUploaderOnDrop(ev: any) {
    ev.preventDefault();
    ev.stopPropagation();
    document.getElementById("dropzone").style.backgroundColor = "rgba(183, 183, 183, 0.1)";
    this.inserisciFile(undefined, ev.dataTransfer.files[0]);
  }
  async onFormEvent(currentOutput: any, guid: string) {

    if (currentOutput.eventName == 'buttonCustomClick' || currentOutput.event == 'caricaFile') {
      await this.gestisciEventoPulsante(currentOutput);
      return;
    }
    if (currentOutput.name == 'formContentReady') {
      this.onAperturaPopupAllegato(currentOutput, guid);
      if (this.stoModificandoAllegato == true) {
        setTimeout(async () => {
          let evt = currentOutput;
          (document.getElementById("dropzone-text") as HTMLElement).style.display = "none";
          let allegatoDaModificare: IFile = currentOutput.accessoringData.allegatoDaModificare;

          this.allegatoDaModificare = allegatoDaModificare;

          evt.masterComponent.updateData('fileOrigine', allegatoDaModificare.fileOrigine);
          evt.masterComponent.updateData('note', allegatoDaModificare.note);
          evt.masterComponent.updateData('idTag', allegatoDaModificare.idTag);
          evt.masterComponent.updateData('parolaChiave', allegatoDaModificare.parolaChiave);

          /*           if (allegatoDaModificare.idTag) {
                      let tag = await this.httpClient.get<IFileTag>(environment.BASE_API_URL.concat(`allegatoTag/${allegatoDaModificare.idTag}`)).toPromise();
                      if (tag)
                        evt.masterComponent.updateData('descrizioneTag', tag.descrizione);
                    } */
          let editorUploadButton = evt.masterComponent.getEditor("uploadFile");
          if (editorUploadButton) {
            editorUploadButton.option("disabled", true);
          }
          this.stoModificandoAllegato = true;
          let estensioneFile = (allegatoDaModificare.fileOrigine as string).split('.')[(allegatoDaModificare.fileOrigine as string).split('.').length - 1].toLowerCase();
          if (!estensioneFile)
            return;
          if (estensioneFile == 'png' || estensioneFile == 'jpeg' || estensioneFile == 'jpg' || estensioneFile == 'svg') {
            let url = environment.BASE_API_URL.concat(this.allegatoDaModificare.percorso);
            (document.getElementById(this.imgFormID) as HTMLImageElement).src = url;
          }
          else if (estensioneFile == 'pdf') {
            (document.getElementById(this.imgFormID) as HTMLImageElement).src = this.filePreviews[estensioneFile]
          }
          else if (estensioneFile == 'xls' || estensioneFile == 'xlsx' || estensioneFile == 'csv') {
            (document.getElementById(this.imgFormID) as HTMLImageElement).src = this.filePreviews[estensioneFile]
          }
          else if (estensioneFile == 'docx' || estensioneFile == 'doc') {
            (document.getElementById(this.imgFormID) as HTMLImageElement).src = this.filePreviews[estensioneFile]
          }
          else if (estensioneFile == 'ppt' || estensioneFile == 'pptx') {
            (document.getElementById(this.imgFormID) as HTMLImageElement).src = this.filePreviews[estensioneFile]
          }
          else if (estensioneFile == 'zip' || estensioneFile == '7zip') {
            (document.getElementById(this.imgFormID) as HTMLImageElement).src = this.filePreviews[estensioneFile]
          }
          else if (estensioneFile == 'txt') {
            (document.getElementById(this.imgFormID) as HTMLImageElement).src = this.filePreviews[estensioneFile]
          }
          else if (estensioneFile == 'rar') {
            (document.getElementById(this.imgFormID) as HTMLImageElement).src = this.filePreviews[estensioneFile]
          }
          else //Tutti gli altri files
            (document.getElementById(this.imgFormID) as HTMLImageElement).src = 'https://upload.wikimedia.org/wikipedia/commons/5/5c/Noun_Project_unknown_icon_762411_cc.svg';
          (document.getElementById(this.imgFormID) as HTMLImageElement).style.display = 'block';
        }, 500);
      }
    }
  }

  inserisciFile(throughInput?: boolean, fileDropped?: File, evt?: any) {
    let t = this;
    let caricaFile = function (input?: HTMLInputElement) {

      t.fileCaricato = (throughInput == true) ? input.files.item(0) : fileDropped;
      if ((t.fileCaricato.size / 1024 / 1024) > 25) {
        t.fileCaricato = undefined;
        t.mimeType = undefined;
        notify({
          message: 'Dimensioni File superiori al limite di 25 MB',
          height: 45,
          width: 250,
          position: 'center center'
        }, 'error', 4000);


        return;
      }

      if (t.fileCaricato.name.split('.')[1].toLowerCase() == 'exe' || t.fileCaricato.name.split('.')[1].toLowerCase() == 'msi' || t.fileCaricato.name.split('.')[1].toLowerCase() == 'bat' || t.fileCaricato.name.toLowerCase().includes('.exe') || t.fileCaricato.name.toLowerCase().includes('.msi') || t.fileCaricato.name.toLowerCase().includes('.bat')) {

        (document.getElementById(t.imgFormID) as HTMLImageElement).style.display = 'none';
        (document.getElementById(t.imgFormID) as HTMLImageElement).src = undefined;

        t.fileCaricato = undefined;
        t.mimeType = undefined;
        t.tempPopupEvent.updateData('fileOrigine', '');

        //alert('Non è possibile allegare files di questo formato!', 'Attenzione');

        notify({
          message: 'Non è possibile allegare files di questo formato!',
          height: 45,
          width: 250,
          position: 'center center'
        }, 'error', 4000);


        return;
      }

      var reader = new FileReader();

      reader.onload = function (event) {
        var dataURL = (event.target as any).result;
        t.mimeType = (dataURL as string).split(",")[0].split(":")[1].split(";")[0];
        //console.debug(t.mimeType);
      };

      reader.readAsDataURL(t.fileCaricato);

      setTimeout(() => {
        console.warn(t.tempPopupEvent);
        t.tempPopupEvent.updateData('fileOrigine', t.fileCaricato.name);

        if (t.mimeType.includes('image')) {
          let url = URL.createObjectURL(t.fileCaricato);
          (document.getElementById(t.imgFormID) as HTMLImageElement).src = url;
        }
        else if (t.mimeType.includes('pdf')) {
          (document.getElementById(t.imgFormID) as HTMLImageElement).src = 'https://upload.wikimedia.org/wikipedia/commons/thumb/3/38/Icon_pdf_file.svg/1795px-Icon_pdf_file.svg.png'; //'https://upload.wikimedia.org/wikipedia/commons/thumb/8/87/PDF_file_icon.svg/1200px-PDF_file_icon.svg.png';
        }
        else if (t.mimeType.includes('sheet') || t.mimeType.includes('spread') || t.mimeType.includes('xls') || t.mimeType.includes('csv')) {
          (document.getElementById(t.imgFormID) as HTMLImageElement).src = 'https://upload.wikimedia.org/wikipedia/commons/thumb/3/31/Microsoft_Office_Excel_%282013%E2%80%932019%29.svg/2048px-Microsoft_Office_Excel_%282013%E2%80%932019%29.svg.png';
        }
        else if (t.mimeType.includes('word')) {
          (document.getElementById(t.imgFormID) as HTMLImageElement).src = 'https://upload.wikimedia.org/wikipedia/commons/thumb/8/8d/Microsoft_Word_2013-2019_logo.svg/254px-Microsoft_Word_2013-2019_logo.svg.png';
        }
        else if (t.mimeType.includes('presentationml') || t.mimeType.includes('powerpoint')) {
          (document.getElementById(t.imgFormID) as HTMLImageElement).src = 'https://upload.wikimedia.org/wikipedia/commons/1/16/Microsoft_PowerPoint_2013-2019_logo.svg';
        }
        else if (t.mimeType.includes('compressed')) {
          (document.getElementById(t.imgFormID) as HTMLImageElement).src = 'https://upload.wikimedia.org/wikipedia/commons/thumb/6/61/7zip_archive_icon.svg/2048px-7zip_archive_icon.svg.png';
        }
        else if (t.mimeType.includes('text/plain')) {
          (document.getElementById(t.imgFormID) as HTMLImageElement).src = 'https://upload.wikimedia.org/wikipedia/commons/thumb/e/e8/.txt_OneDrive_icon.svg/1200px-.txt_OneDrive_icon.svg.png';
        }
        else if (t.fileCaricato.name.split('.')[1].toLowerCase() == 'rar') {
          (document.getElementById(t.imgFormID) as HTMLImageElement).src = 'https://www.wikibit.it/wp-content/uploads/2017/06/rar.png';
        }
        else //Tutti gli altri files
          (document.getElementById(t.imgFormID) as HTMLImageElement).src = 'https://upload.wikimedia.org/wikipedia/commons/5/5c/Noun_Project_unknown_icon_762411_cc.svg';
        (document.getElementById(t.imgFormID) as HTMLImageElement).style.display = 'block';
        (document.getElementById("dropzone-text") as HTMLElement).style.display = "none";
      }, 500);
    }
    if (throughInput == true) {
      let input = document.createElement('input');
      input.type = 'file';
      input.style.display = 'none';
      input.multiple = false;
      input.onchange = () => {
        caricaFile(input);
      }
      input.click();
    }
    else
      caricaFile();
  }

  async gestisciEventoPulsante(evt: any) {
    switch (evt.name) {
      case 'annulla': {
        evt.masterComponent.formEdit.instance.resetValues();
        this.userComponentService.destroyCurrentOpenPopUp('NicaFormComponent');
        this.onChiudiPopupAllegato(evt);
      } break;
      case 'salva': {

        let formData: FormData = new FormData();
        const note = evt.masterComponent.formEdit.formData.note;
        const idTag = evt.masterComponent.formEdit.formData.idTag;
        const parolaChiave = evt.masterComponent.formEdit.formData.parolaChiave;

        formData.append('file', this.fileCaricato);

        formData.set('nomeTabella', this.nomeTabella);
        formData.set('idTabella', this.idTabella.toString());

        if (this.nomeTabellaPadre)
          formData.set('nomeTabellaPadre', this.nomeTabellaPadre);

        if (this.idTabellaPadre)
          formData.set('idTabellaPadre', this.idTabellaPadre.toString());

        if (this.fileCaricato) {
          formData.set('fileOrigine', this.fileCaricato.name);


          formData.set('tipoFile', this.mimeType);
          formData.set('dimensione', this.fileCaricato.size.toString());
        }


        formData.set('note', typeof note != 'undefined' ? note : ''); //Letti dal Nica Form

        formData.set('idTag', typeof idTag != 'undefined' ? idTag : '');

        formData.set('parolaChiave', typeof parolaChiave != 'undefined' ? parolaChiave : '');

        let validate = evt.masterComponent.formEdit.instance.validate();

        evt.masterComponent.formEdit.showValidationSummary = false;

        if (!validate.isValid)
          return;

        //PUT
        if (this.stoModificandoAllegato == true) {

          this.allegatoDaModificare.note = note;
          this.allegatoDaModificare.idTag = idTag;
          this.allegatoDaModificare.parolaChiave = parolaChiave;

          await this.httpClient.put<any>(environment.BASE_API_URL.concat(`Allegato/${this.allegatoDaModificare.id}`), JSON.stringify(this.allegatoDaModificare), { headers: { "content-type": "application/json" } }).toPromise();

          notify({
            message: 'Allegato modificato con successo',
            height: 45,
            width: 250,
            position: 'center center'

          }, 'success', 3000);


        }
        //POST
        else {
          if (!this.fileCaricato) {

            notify({
              message: 'Si prega di caricare un file prima di procedere',
              height: 45,
              width: 250,
              position: 'center center'
            }, 'error', 3000);



            return;
          }
          await this.httpClient.post(environment.BASE_API_URL.concat('Allegato'), formData).toPromise();
          notify({
            message: 'Allegato aggiunto con successo',
            height: 45,
            width: 250,
            position: 'center center'
          }, 'success', 3000);

        }
        evt.masterComponent.formEdit.instance.resetValues();
        this.dataGridAllegati.refresh();
        this.userComponentService.destroyCurrentOpenPopUp('NicaFormComponent');

        this.onChiudiPopupAllegato(evt);
      } break;
    }

    if (evt.event && evt.event == 'caricaFile') {
      this.inserisciFile(true, undefined, evt);

    }

  }
  onAperturaPopupAllegato(evt: any, guid: string) {
    //console.warn(evt);
    let form: JQuery<HTMLElement> = $(`#${guid} app-nica-form`);   //document.getElementsByTagName('app-nica-form').item(0);
    //console.warn(form);

    if (form) {

      form.addClass("formEditPopup"); //add class to overlay content
      form.addClass("formEditPopupContet"); //add class to content
      form.addClass("bg-grey"); //add class to content
      form.addClass("soggetto-form"); //add class to content
    }

    if (evt.masterComponent)
      this.tempPopupEvent = evt.masterComponent;
    else
      this.tempPopupEvent = undefined;
    window.onresize = () => {
      //console.warn('sto ridimensionando', this.fileCaricato, this.mimeType);
      if ((document.getElementById('dropzone-image') as HTMLImageElement).style.display == 'none') {
        //console.warn(this.mimeType, this.fileCaricato)

        if (this.stoModificandoAllegato == true) {

          let estensioneFile = (this.allegatoDaModificare.fileOrigine as string).split('.')[(this.allegatoDaModificare.fileOrigine as string).split('.').length - 1].toLowerCase();

          if (!estensioneFile) return;

          if (estensioneFile == 'png' || estensioneFile == 'jpeg' || estensioneFile == 'jpg' || estensioneFile == 'svg') {
            let url = environment.BASE_API_URL.concat(this.allegatoDaModificare.percorso);    //URL.createObjectURL(this.allegatoDaModificare.percorso);
            (document.getElementById(this.imgFormID) as HTMLImageElement).src = url;
          }
          else if (estensioneFile == 'pdf') {
            (document.getElementById(this.imgFormID) as HTMLImageElement).src = this.filePreviews[estensioneFile]
          }
          else if (estensioneFile == 'xls' || estensioneFile == 'xlsx' || estensioneFile == 'csv') {
            (document.getElementById(this.imgFormID) as HTMLImageElement).src = this.filePreviews[estensioneFile]
          }
          else if (estensioneFile == 'docx' || estensioneFile == 'doc') {
            (document.getElementById(this.imgFormID) as HTMLImageElement).src = this.filePreviews[estensioneFile]
          }
          else if (estensioneFile == 'ppt' || estensioneFile == 'pptx') {
            (document.getElementById(this.imgFormID) as HTMLImageElement).src = this.filePreviews[estensioneFile]
          }
          else if (estensioneFile == 'zip' || estensioneFile == '7zip') {
            (document.getElementById(this.imgFormID) as HTMLImageElement).src = this.filePreviews[estensioneFile]
          }
          else if (estensioneFile == 'txt') {
            (document.getElementById(this.imgFormID) as HTMLImageElement).src = this.filePreviews[estensioneFile]
          }
          else if (estensioneFile == 'rar') {
            (document.getElementById(this.imgFormID) as HTMLImageElement).src = this.filePreviews[estensioneFile]
          }
          else //Tutti gli altri files
            (document.getElementById(this.imgFormID) as HTMLImageElement).src = 'https://upload.wikimedia.org/wikipedia/commons/5/5c/Noun_Project_unknown_icon_762411_cc.svg';
          (document.getElementById(this.imgFormID) as HTMLImageElement).style.display = 'block';
        }
        else if (this.mimeType) {
          if (this.mimeType.includes('pdf')) {
            (document.getElementById('dropzone-image') as HTMLImageElement).src = 'https://upload.wikimedia.org/wikipedia/commons/thumb/3/38/Icon_pdf_file.svg/1795px-Icon_pdf_file.svg.png'; //'https://upload.wikimedia.org/wikipedia/commons/thumb/8/87/PDF_file_icon.svg/1200px-PDF_file_icon.svg.png';
          }
          else if (this.mimeType.includes('sheet') || this.mimeType.includes('spread') || this.mimeType.includes('xls') || this.mimeType.includes('csv')) {
            (document.getElementById('dropzone-image') as HTMLImageElement).src = 'https://upload.wikimedia.org/wikipedia/commons/thumb/3/31/Microsoft_Office_Excel_%282013%E2%80%932019%29.svg/2048px-Microsoft_Office_Excel_%282013%E2%80%932019%29.svg.png';
          }
          else if (this.mimeType.includes('word')) {
            (document.getElementById('dropzone-image') as HTMLImageElement).src = 'https://upload.wikimedia.org/wikipedia/commons/thumb/8/8d/Microsoft_Word_2013-2019_logo.svg/254px-Microsoft_Word_2013-2019_logo.svg.png';
          }
          else if (this.mimeType.includes('presentationml') || this.mimeType.includes('powerpoint')) {
            (document.getElementById('dropzone-image') as HTMLImageElement).src = 'https://upload.wikimedia.org/wikipedia/commons/1/16/Microsoft_PowerPoint_2013-2019_logo.svg';
          }
          else if (this.mimeType.includes('compressed')) {
            (document.getElementById('dropzone-image') as HTMLImageElement).src = 'https://upload.wikimedia.org/wikipedia/commons/thumb/6/61/7zip_archive_icon.svg/2048px-7zip_archive_icon.svg.png';
          }
          else if (this.mimeType.includes('text/plain')) {
            (document.getElementById('dropzone-image') as HTMLImageElement).src = 'https://upload.wikimedia.org/wikipedia/commons/thumb/e/e8/.txt_OneDrive_icon.svg/1200px-.txt_OneDrive_icon.svg.png';
          }
          else if (this.fileCaricato.name.split('.')[1].toLowerCase() == 'rar') {
            (document.getElementById('dropzone-image') as HTMLImageElement).src = 'https://www.wikibit.it/wp-content/uploads/2017/06/rar.png';
          }
          else //Tutti gli altri files
            (document.getElementById('dropzone-image') as HTMLImageElement).src = 'https://upload.wikimedia.org/wikipedia/commons/5/5c/Noun_Project_unknown_icon_762411_cc.svg';
          let url = URL.createObjectURL(this.fileCaricato);
          (document.getElementById('dropzone-image') as HTMLImageElement).src = url;
        }
        (document.getElementById('dropzone-image') as HTMLImageElement).style.display = 'block';
        (document.getElementById("dropzone-text") as HTMLElement).style.display = "none";
      }
    }
    setTimeout(() => {

      if ((document.getElementById('dropzone-image') as HTMLImageElement)) {
        (document.getElementById('dropzone-image') as HTMLImageElement).ondragstart = function () { return false; };
      }
      if (this.stoModificandoAllegato == true)
        return;
      document.body.addEventListener("dragenter", this.fileUploaderEventMouseMoving, false);
      document.body.addEventListener("dragover", this.fileUploaderEventMouseMoving, false);
      document.body.addEventListener("dragleave", this.fileUploaderEventMouseMoving, false);
    }, 500);
  }
  async onChiudiPopupAllegato(evt) {

    this.allegatoDaModificare = undefined;
    this.stoModificandoAllegato = false;
    this.tempPopupEvent = undefined;

    this.captionAllegati = "Inserimento Allegato";

    document.body.removeEventListener("dragenter", this.fileUploaderEventMouseMoving, false);
    document.body.removeEventListener("dragover", this.fileUploaderEventMouseMoving, false);
    document.body.removeEventListener("dragleave", this.fileUploaderEventMouseMoving, false);
    //document.getElementById('dropzone').removeEventListener("drop",this.fileUploaderOnDrop,false);
    window.onresize = () => {
      return;
    }
  }
  chiudiPopupAnteprima(evt) {
    this.mostraPopupAnteprima = false;
    this.anteprimaPDF.clear();
  }

}


